import React from "react";
import MenuButton from "../MenuButton/MenuButton";
import FinanceV2ModuleNav from "./FinanceV2ModuleNav";
import "./FinanceV2.css";

/**
 * Matches FinanceDashboard / app shell so content clears the fixed sidebar.
 */
export default function FinanceV2Layout({ children, hideNav = false }) {
  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <MenuButton />
          <div className="finance-v2-page">
            {!hideNav && <FinanceV2ModuleNav />}
            {children}
          </div>
        </div>
      </main>
    </div>
  );
}
